import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalUploadFile } from "./ModalUploadFile";

export const useModalUploadFile = () =>
  useWSModal(ModalUploadFile, {
    title: "Upload document",
    size: "S"
  });
